export enum InterpolationType {
  LINEAR_INTERPOLATION = 'LINEAR_INTERPOLATION',
  SPLINE_INTERPOLATION = 'SPLINE_INTERPOLATION',
}
